module.exports = __webpack_public_path__ + "static/img/ubank.bfdf1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-30/ubank.png
// module id = /bmm
// module chunks = 6